import React from 'react';

import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Grid from '@mui/material/GridLegacy';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Helmet } from 'react-helmet-async';

import Container from 'components/Container';

// Define base props interface
interface PropTypes {
  children?: React.ReactNode;
  banner?: React.ReactElement;
  title?: string | React.ReactElement;
  subtitle?: string | React.ReactElement;
  menuComponent?: React.ReactNode;
}

export function StudentPage({ banner, title, subtitle, children, menuComponent }: PropTypes): JSX.Element {
  const theme = useTheme();
  const isSm = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box>
      <Helmet>
        <title>{title}</title>
      </Helmet>
      {banner && <Box>{banner}</Box>}
      <Box bgcolor={'primary.main'} paddingBottom={4}>
        <Container>
          {title && typeof title === 'string' && (
            <Typography variant="h4" fontWeight={700} gutterBottom sx={{ color: 'common.white' }}>
              {title}
            </Typography>
          )}
          {title && typeof title !== 'string' && title}

          {subtitle && typeof subtitle === 'string' && (
            <Typography variant="h6" sx={{ color: 'common.white' }} gutterBottom>
              {subtitle}
            </Typography>
          )}

          {subtitle && typeof subtitle !== 'string' && subtitle}
        </Container>
      </Box>
      <Container paddingTop={'0 !important'} marginTop={-8} paddingX={isSm ? 0 : 2}>
        <Grid container gap={3}>
          {menuComponent && (
            <Grid item xs={12} md="auto">
              <Card sx={{ boxShadow: 3, padding: 0 }}>{menuComponent}</Card>
            </Grid>
          )}

          {children && (
            <Grid item xs={12} md>
              <Card sx={{ boxShadow: 3, padding: 2 }}>{children}</Card>
            </Grid>
          )}
        </Grid>
      </Container>
    </Box>
  );
}

export default StudentPage;
